import { __rest } from "tslib";
import React from 'react';
const DropdownButton = (_a) => {
    var { className, disabled } = _a, _b = _a.buttonProps, { children: buttonChildren } = _b, buttonProps = __rest(_b, ["children"]), { initialState = false, onShowCallback, buttonComponent, children: renderChildren } = _a;
    const [isVisible, setIsVisible] = React.useState(initialState);
    const [isKbTriggered, setIsKbTriggered] = React.useState(false);
    const buttonRef = React.useRef(null);
    React.useEffect(() => {
        if (isVisible) {
            document.addEventListener('click', hideDropdown);
            document.addEventListener('keyup', handleCloseDropdown);
        }
        return () => {
            document.removeEventListener('click', hideDropdown);
            document.removeEventListener('keyup', handleCloseDropdown);
        };
    }, [isVisible]);
    const hideDropdown = () => {
        var _a;
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        setIsVisible(false);
    };
    const handleCloseDropdown = (e) => {
        var _a;
        if (e.key === 'Escape' || e.key === 'Tab') {
            e.key === 'Escape' && ((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus());
            setIsVisible(false);
        }
    };
    const Component = buttonComponent ? buttonComponent : 'button';
    const children = typeof renderChildren === 'function' ? renderChildren(isKbTriggered) : renderChildren;
    return (React.createElement("div", { className: className },
        React.createElement(Component, Object.assign({}, buttonProps, { onClick: () => {
                if (!disabled) {
                    setIsKbTriggered(false);
                    setIsVisible(true);
                    onShowCallback === null || onShowCallback === void 0 ? void 0 : onShowCallback();
                }
            }, onKeyDown: (e) => {
                if (e.key === 'Enter' || (e.key === ' ' && !disabled)) {
                    e.preventDefault();
                    setIsKbTriggered(true);
                    setIsVisible(true);
                    onShowCallback === null || onShowCallback === void 0 ? void 0 : onShowCallback();
                }
            }, "aria-haspopup": "true", "aria-expanded": isVisible, ref: buttonRef }), buttonChildren ? buttonChildren : null),
        isVisible ? children : null));
};
export default DropdownButton;
//# sourceMappingURL=dropdown-button.js.map